import { isObject } from 'lodash'
import { api } from '@/global/services/api'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'

export default {
  name: 'tableConfig',

  data () {
    return {
      changeStatusDialogConfig: {
        show: false,
        apiConfig: {
          module: 'fleet',
          route: 'travel-documents/change-status',
          method: 'post'
        },
        getStatusesApiConfig: {
          module: 'fleet',
          route: 'travel-documents/statuses',
          method: 'get'
        },
        title: this.$t('fleet/documents/prl_cargo.select_new_status'),
        statuses: [],
        current_status: null,
        document_id: null,
        callback: null
      },
      informationDialogData: {
        show: false,
        message: '',
        cancelText: '',
        confirmText: '',
        title: '',
        callback: null
      }
    }
  },

  computed: {
    tableConfig () {
      return {
        tableConfig: {
          apiConfig: {
            get: {
              module: 'fleet',
              route: 'travel-documents/disposition',
              method: 'get'
            }
          },
          rowDblClick: (event) => this.showDispositionDetails(event),
          search_and_buttons_config: {
            newClick: (event) => this.showCreateNewDisposition(event)
          },
          title_and_back_config: {
            title: this.$t('fleet.disposition')
          },
          tableConfig: {
            cellsConfig: {
              status: {
                type: 'status',
                custom_display_value: (data) => {
                  if (data && data.status && isObject(data.status)) {
                    return {
                      ...data.status,
                      ...{
                        description: data.status.description ? this.$t(data.status.description) : '-'
                      }
                    }
                  }
                },
                displayValue: 'description',
                colorObjectKey: 'color',
                textColorKey: 'text',
                backgroundColorKey: 'background'
              }
            },
            headers: [
              {
                label: this.$t('fleet/documents/prl_cargo.sr_no'),
                key: 'id',
                always_visible: true
              },
              {
                label: this.$t('fleet/documents/machine.machine_operation_document_number'),
                key: 'foreign_code',
                always_visible: true
              },
              {
                label: this.$t('fleet/documents/prl_cargo.date'),
                key: 'date_time',
                always_visible: true
              },
              {
                label: this.$t('fleet/vehicle.registration'),
                key: 'vehicle_registration',
                initial_value: true
              },
              {
                label: this.$t('fleet/vehicle_attribute.garage_number'),
                key: 'vehicle_garage_number',
                initial_value: true
              },
              {
                label: this.$t('fleet/vehicle.label'),
                key: 'vehicle_brand',
                initial_value: true
              },
              {
                label: this.$t('fleet/documents/disposition.customer'),
                key: 'client_name',
                initial_value: true
              },
              {
                label: this.$t('fleet/documents/machine.document_creation_date_time'),
                key: 'created_at',
                always_visible: true
              },
              {
                label: this.$t('fleet/vehicle.status'),
                key: 'status',
                style: {
                  width: '120px'
                },
                always_visible: true
              }
            ],
            paginationConfig: {
              perPageOptions: [20, 50, 100],
              perPage: 20,
              currentPage: 1
            },
            actionsConfig: [
              showDetailsAction(this.$t, (event) => this.showDispositionDetails(event)),
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                icon: 'mdi-swap-horizontal',
                click: (event) => this.onChangeStatus(event)
              },
              {
                ...deleteAction(this.$t, (event) => this.onDocumentDelete(event)),
                visible: (event) => {
                  const { permissions } = event?.data || null

                  return permissions && permissions.canDelete
                }
              }
            ],
            filtersConfig: {
              fields: [
                {
                  key: 'id',
                  label: this.$t('fleet/documents/prl_cargo.sr_no')
                },
                {
                  key: 'foreign_code',
                  label: this.$t('fleet/documents/prl_cargo.prl_no')
                },
                {
                  key: 'date_time',
                  label: this.$t('fleet/documents/prl_cargo.creation_date')
                },
                {
                  key: 'vehicle_registration',
                  label: this.$t('fleet/vehicle.registration'),
                  type: 'autocomplete',
                  autocomplete_options: {
                    module: 'fleet',
                    route: 'travel-documents/get-vehicle',
                    custom_display_value: (value) => {
                      return value && value.vehicle_registration ? value.vehicle_registration : null
                    },
                    additionalQueryParams: {
                      by: 'registration',
                      vehicle_type: 'vehicle',
                      document_type: 'DISPOSITION'
                    },
                    form_value: 'vehicle_registration'
                  }
                },
                {
                  key: 'vehicle_garage_number',
                  label: this.$t('fleet/vehicle_attribute.garage_number'),
                  type: 'autocomplete',
                  autocomplete_options: {
                    module: 'fleet',
                    route: 'travel-documents/get-vehicle',
                    custom_display_value: (value) => {
                      return value && value.vehicle_garage_number ? value.vehicle_garage_number : null
                    },
                    additionalQueryParams: {
                      by: 'garage_number',
                      vehicle_type: 'vehicle',
                      document_type: 'DISPOSITION'
                    },
                    form_value: 'vehicle_garage_number'
                  }
                },
                {
                  key: 'vehicle_brand',
                  label: this.$t('fleet/vehicle.label'),
                  type: 'autocomplete',
                  autocomplete_options: {
                    module: 'fleet',
                    route: 'travel-documents/get-vehicle',
                    custom_display_value: (value) => {
                      return value && value.vehicle_brand ? value.vehicle_brand : null
                    },
                    additionalQueryParams: {
                      by: 'registration',
                      vehicle_type: 'vehicle',
                      document_type: 'DISPOSITION'
                    },
                    form_value: 'vehicle_brand'
                  }
                },
                {
                  key: 'client_name',
                  label: this.$t('fleet/documents/disposition.customer')
                },
                {
                  key: 'created_at',
                  label: this.$t('fleet/documents/machine.document_creation_date_time')
                },
                {
                  key: 'status',
                  label: this.$t('fleet/vehicle.status'),
                  type: 'autocomplete',
                  autocomplete_options: {
                    module: 'fleet',
                    route: 'travel-documents/statuses',
                    custom_display_value: (value) => {
                      const { description } = value || null
                      return description && typeof description === 'string' ? this.$t(description) : ''
                    },
                    form_value: 'description'
                  }
                }
              ]
            }
          }
        },
        breadcrumbs: {
          items: [
            {
              text: this.$t('fleet.travel_documents')
            },
            {
              text: this.$t('fleet.disposition'),
              bolded: true
            }
          ]
        }
      }
    }
  },

  methods: {
    showDispositionDetails (event) {
      const { data } = event || {}
      const { id, foreign_code: foreignCode } = data || {}

      if (id) {
        this.$router.push({
          name: 'DispositionDetailsView',
          params: {
            id
          },
          query: {
            bread_crumb_value: foreignCode ?? null
          }
        }).then()
      }
    },

    redirectToEdit (event, data) {
      const { id, foreign_code: foreignCode } = data || {}

      if (id) {
        this.$router.push({
          name: 'DispositionDetailsView',
          params: {
            id,
            breadCrumbValue: foreignCode ?? this.$t('fleet/documents/prl_cargo.document_edit')
          }
        }).then()
      }
    },

    async onChangeStatus (event) {
      const { id } = event?.data?.status || {}
      const { id: documentId } = event?.data || {}
      const { fetchTableData } = event || null

      if (this.changeStatusDialogConfig.statuses.length) {
        this.$set(this.changeStatusDialogConfig, 'current_status', id)
        this.$set(this.changeStatusDialogConfig, 'document_id', documentId)
        if (typeof fetchTableData === 'function') {
          this.$set(this.changeStatusDialogConfig, 'callback', () => fetchTableData())
        }
        this.$set(this.changeStatusDialogConfig, 'show', true)
      }
      else {
        const { method, module, route } = this.changeStatusDialogConfig?.getStatusesApiConfig || {}

        if (method && module && route) {
          const { data } = await api()[module][method](route)
          if (data && data.length) {
            this.$set(this.changeStatusDialogConfig, 'statuses', data)
            this.$set(this.changeStatusDialogConfig, 'current_status', id)
            this.$set(this.changeStatusDialogConfig, 'document_id', documentId)
            if (typeof fetchTableData === 'function') {
              this.$set(this.changeStatusDialogConfig, 'callback', () => fetchTableData())
            }
            this.$set(this.changeStatusDialogConfig, 'show', true)
          }
        }
      }
    },

    async closeChangeStatusDialog () {
      this.$set(this.changeStatusDialogConfig, 'show', false)
    },

    showCreateNewDisposition (event) {
      if (event && event.showTableNewPage && typeof event.showTableNewPage === 'function') {
        event.showTableNewPage()
      }
    },

    async onDocumentDelete (event) {
      try {
        this.$set(this.informationDialogData, 'message', this.$t('fleet/documents/prl_cargo.delete_document_message'))
        this.$set(this.informationDialogData, 'cancelText', this.$t('base.cancel'))
        this.$set(this.informationDialogData, 'confirmText', this.$t('base.confirm'))
        this.$set(this.informationDialogData, 'title', this.$t('fleet/vehicle/documents_tab.delete_dialog_title'))
        this.$set(this.informationDialogData, 'callback', async () => await this.deleteDocumentCallback(event))
        this.$set(this.informationDialogData, 'show', true)
      }
      catch (exception) {
        console.log(exception)
      }
    },

    async deleteDocumentCallback (event) {
      try {
        const { id } = event?.data || {}
        const { fetchTableData } = event || {}

        if (id) {
          await api().fleet.delete(`travel-documents/disposition/${id}`)

          // Close confirmation dialog
          this.$set(this.informationDialogData, 'show', false)

          // Refresh table data after successfully document delete
          if (typeof fetchTableData === 'function') {
            fetchTableData()
          }
        }
      }
      catch (exception) {
        this.$set(this.informationDialogData, 'show', false)
        console.log(exception)
      }
    },

    onCloseInformationDialog () {
      this.$set(this.informationDialogData, 'show', false)
    }
  }
}
